import { render, staticRenderFns } from "./SectionParallax.vue?vue&type=template&id=1d3061b8&"
import script from "./SectionParallax.vue?vue&type=script&lang=js&"
export * from "./SectionParallax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports